import React from 'react';
import { classNames } from "../../helper/classNames";
const SuccessionPlanItem = ({data}) => {
  return (
      <div className="relative bg-white border-2 border-neutral-50 p-2 lg:p-4 xl:p-7 rounded-lg shadow-lg shadow-slate-950">
           <div className="flex flex-col space-y-1">
              <h4 className="font-PlusJakartaSans font-bold text-sm xl:text-xl text-slate-800 capitalize text-center">{data.title}</h4>
              <div dangerouslySetInnerHTML={{__html:data.description}} className="text-xs xl:text-sm font-Inter text-slate-800 text-center"></div>
           </div>
            
      </div>
  );
};

export default SuccessionPlanItem;